import { Card } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Icon } from '@iconify/react';
import ClipLoader from 'react-spinners/ClipLoader';
import { useQuery } from 'react-query';
import {
    getAllEquipmentUnitCategoriesByProfileId, addNewEquipmentUnitCategory,
    updateEquipmentUnitCategory
} from '../../../../api';
import { useEffect, useRef, useState } from 'react';
import {
    checkForAPISuccess, checkIfNoRecords, showErrorToast,
    showInfoToast, showSuccessToast
} from './../../../../Common/commonFunctions';
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
    SET_CATEGORIES, SELECT_OR_DESELECT_CATEGORY, SET_NEW_CATEGORY_ADD_FLAG,
    APPEND_NEWLY_ADDED_CATEGORY, SET_CATEGORY_IN_EDIT,
    CANCEL_CATEGORY_EDIT, UPDATE_CATEGORY
} from './../../../../store/actions';
import {
    RESPONSE_CATEGORY_JSON_ERROR, RESPONSE_CATEGORY_NAME_TAKEN_CODE, 
    RESPONSE_TEMPLATE_BEARING_COMBINATION_CODE, 
    RESPONSE_TEMPLATE_COMPONENTS_MISMATCH_CODE 
} from '../../../../Common/constants';
import CustomToggle from '../../Common/CustomToggle';
import Dropdown from 'react-bootstrap/Dropdown';
import ToolTip from '../../Common/Tooltip';
import Searchfield from './../../Common/Searchfield';
import useSearch from './../../../hooks/index';
import GlobalCategoriesPopup from './GlobalCategoriesPopup';
import JsonSchemaBasedErrorPopup from './JsonSchemaBasedErrorPopup';
import DeleteCategoryPopup from './DeleteCategoryPopup';
import AddOrUpdateCategoryLoadingPopup from './AddOrUpdateCategoryLoadingPopup';

const CategoryList = props => {

    const dispatch = useDispatch();
    const categories = useSelector(state => state.category.categories);
    const selectedCategoryId = useSelector(state => state.category.selectedCategoryId);
    const isAddOrEditActive = useSelector(state => state.category.isAddOrEditActive);
    const categoryJson = useSelector(state => state.category.categoryJson);
    const searchHook = useSearch();

    const isLockedProfile = useRef(false);

    const [utils, setUtils] = useState({
        jsonErrors: [], categoryToDelete: { id: "", name: "" },
        categoryInitialInfo: { name: '', json: {} },
        categoryCurrentInfo: { name: '', json: {} },
        isInvalidJson: false, showSearchBox: false,
        categoriesList: [], showGlobalCategoriesPopup: false
    });

    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const fetchCategories = async () => {
        const response = await getAllEquipmentUnitCategoriesByProfileId(props.checkIfUserInGlobalCategoriesPage() ? '' : props.profileId);
        return response?.data;
    }

    const addNewCategory = async () => {
        const response = await addNewEquipmentUnitCategory({
            name: utils.categoryCurrentInfo.name,
            categoryJson: utils.categoryCurrentInfo.json,
            profileId: props.checkIfUserInGlobalCategoriesPage() ? "" : props.profileId
        });
        return response?.data;
    }

    const updateCategory = async () => {
        const response = await updateEquipmentUnitCategory({
            id: selectedCategoryId,
            name: utils.categoryCurrentInfo.name, 
            categoryJson: utils.categoryCurrentInfo.json,
            profileId: props.checkIfUserInGlobalCategoriesPage() ? "" : props.profileId
        });
        return response?.data;
    }

    const fetchCategoriesQuery = useQuery('get-categories', fetchCategories, { ...useQueryConfiguration });
    const addCategoryQuery = useQuery('add-category', addNewCategory, { ...useQueryConfiguration });
    const updateCategoryQuery = useQuery('update-category', updateCategory, { ...useQueryConfiguration });

    const isAnyCategoryInEditCurrently = () => isAddOrEditActive && !_.isEmpty(selectedCategoryId);

    const isDetailsUnchangedInEdit = () =>
        _.isEqual(utils.categoryCurrentInfo.name, utils.categoryInitialInfo.name) &&
        _.isEqual(utils.categoryCurrentInfo.json, utils.categoryInitialInfo.json);

    const checkProvidedDetailsIsValid = () => {
        let isValid = false;
        try {
            isValid =
                !_.isEmpty(utils.categoryCurrentInfo.name) &&
                !utils.isInvalidJson &&
                !_.isEmpty(utils.categoryCurrentInfo.name) &&
                Object.keys(utils.categoryCurrentInfo.json).length > 0;
        } catch (error) {
            isValid = false;            
        }
        return isValid;
    }

    const shouldDenySave = () => {
        let disableSave = true;
        if(checkProvidedDetailsIsValid()) {
            if(isAnyCategoryInEditCurrently()) {
                disableSave = isDetailsUnchangedInEdit();
            }
            else {
                disableSave = false;
            }
        }
        return disableSave;
    }

    const returnCategoryAddOrEditField = () =>
        <div className={`category-item bg-hover`}>
            <input
                value={!_.isEmpty(utils.categoryCurrentInfo.name) ? utils.categoryCurrentInfo.name : ""}
                onChange={e => setUtils({ ...utils, categoryCurrentInfo: { ...utils.categoryCurrentInfo, name: e.target.value } })}
                className='ml-3 vertical-center-align border-none h-50 w-80'
            />
            <div className='categroy-add-edit-field'>
                {
                    returnIconBasedToolTip(
                        '',
                        'feather-x',
                        '#075978', 
                        () => handleIcons("CANCEL"), 
                        isAnyCategoryInEditCurrently() ? "cancel-edit" : "cancel-add",
                        "Cancel",
                    )
                }
                {
                    returnIconBasedToolTip(
                        shouldDenySave() ? "disable-click" : "",
                        'feather-save',
                        shouldDenySave() ? 'grey' : '#075978',
                        () => isAnyCategoryInEditCurrently() ? updateCategoryQuery.refetch() : addCategoryQuery.refetch(),
                        isAnyCategoryInEditCurrently() ? "update-category" : "add-category",
                        isAnyCategoryInEditCurrently() ? "Update" : "Add"
                    )
                }
            </div>
        </div>

    const returnDropdownItem = (icon, action, callBack, iconClass, iconColor, showIcon) =>
        <Dropdown.Item className="category-item-drop-down" onClick={() => callBack()}>
            {
                showIcon && <Icon className={iconClass} width={20} height={20} color={iconColor} icon={icon} />
            }
            <div>
                {action}
            </div>
        </Dropdown.Item>

    const returnIconBasedToolTip = (className, icon, color, callBack, key, value) =>
        <ToolTip
            toolTipKey={key} toolTipValue={value}
            overlayComponent={
                <Icon width={20} height={20} className={className} icon={icon} onClick={() => callBack()} color={color} />
            }
        />

    const handleIcons = (action) => {
        if(action === "ADD") {
            setUtils({ ...utils, categoryCurrentInfo: {}, categoryInitialInfo: {} });
            dispatch({ type: SET_NEW_CATEGORY_ADD_FLAG, payload: true });
        }
        else if(action === "CANCEL") {
            dispatch({
                type: isAnyCategoryInEditCurrently() ? CANCEL_CATEGORY_EDIT : SET_NEW_CATEGORY_ADD_FLAG,
                payload: isAnyCategoryInEditCurrently() ? utils.categoryInitialInfo.json : false
            });
        }
    }

    const returnFilteredCategoriesList = () => !_.isEmpty(searchHook.searchValue) ? searchHook.filterList(categories, 'name') : categories;

    useEffect(() => {
        fetchCategoriesQuery.refetch();
    }, []);

    useEffect(() => {
        if(!_.isEmpty(selectedCategoryId)) {
            const categoryInEdit = categories.filter((category) => category.id === selectedCategoryId)?.[0];
            const categoryObj = { name: categoryInEdit?.name, json: categoryInEdit?.categoryJson };
            setUtils({
                ...utils, categoryCurrentInfo: _.cloneDeep(categoryObj),
                categoryInitialInfo: _.cloneDeep(categoryObj),
                categoriesList: returnFilteredCategoriesList()
            });
        }
        else {
            setUtils({
                ...utils, categoryCurrentInfo: {}, categoryInitialInfo: {},
                categoryToDelete: {}, categoriesList: returnFilteredCategoriesList()
            });
        }
    }, [isAddOrEditActive, selectedCategoryId]);

    useEffect(() => {
        try {
            if(isAddOrEditActive) {
                setUtils({
                     ...utils, isInvalidJson: false, showGlobalCategoriesPopup: false,
                     categoryCurrentInfo: { ...utils.categoryCurrentInfo, json: typeof categoryJson === 'object' ? categoryJson : JSON.parse(categoryJson) }
                });
            }
        } catch (error) {
            setUtils({ ...utils, isInvalidJson: true });
        }
    }, [categoryJson]);

    useEffect(() => {
        setUtils({ ...utils, categoriesList: returnFilteredCategoriesList() });
    }, [searchHook.searchValue]);

    useEffect(() => {
        if(fetchCategoriesQuery.isFetched) {
            if(
                checkForAPISuccess(fetchCategoriesQuery?.data?.statusCode) ||
                checkIfNoRecords(fetchCategoriesQuery?.data?.statusCode)
            ) {
                isLockedProfile.current = fetchCategoriesQuery?.data?.data?.isLockedProfile;
                setUtils({ ...utils, categoriesList: fetchCategoriesQuery?.data?.data?.categories });
                dispatch({ type: SET_CATEGORIES, payload: fetchCategoriesQuery.data?.data?.categories });
            }
            else {
                showErrorToast('Failed to get Equipment Unit Categories', 5000);
            }
            fetchCategoriesQuery.remove();
        }
        if(addCategoryQuery.isFetched) {
            if(checkForAPISuccess(addCategoryQuery?.data?.statusCode)) {
                showSuccessToast(`Added ${utils.categoryCurrentInfo.name} successfully`);
                setUtils({ ...utils, categoryCurrentInfo: { name: "", json: {} } });
                dispatch({ type: APPEND_NEWLY_ADDED_CATEGORY, payload: addCategoryQuery.data.data });
            }
            else if(_.isEqual(addCategoryQuery?.data?.statusCode, RESPONSE_CATEGORY_NAME_TAKEN_CODE)) {
                showInfoToast(`Provided name ${utils.categoryCurrentInfo.name} is taken. Please provide a different name.`, 6000);
            }
            else if(_.isEqual(addCategoryQuery?.data?.statusCode, RESPONSE_CATEGORY_JSON_ERROR)) {
                setUtils({ ...utils, jsonErrors: addCategoryQuery.data?.data });
            }
            else {
                showErrorToast(`Failed to add ${utils.categoryCurrentInfo.name}`, 5000);
            }
            addCategoryQuery.remove();
        }
        if(updateCategoryQuery.isFetched) {
            if(checkForAPISuccess(updateCategoryQuery?.data?.statusCode)) {
                showSuccessToast(`Category ${utils.categoryCurrentInfo.name} updated successfully`, 3000);
                setUtils({ ...utils, categoryInitialInfo: _.cloneDeep(utils.categoryCurrentInfo) });
                dispatch({ type: UPDATE_CATEGORY, payload: _.cloneDeep(utils.categoryCurrentInfo) });
            }
            else if(_.isEqual(updateCategoryQuery?.data?.statusCode, RESPONSE_CATEGORY_NAME_TAKEN_CODE)) {
                showInfoToast(`Provided name ${utils.categoryCurrentInfo.name} is taken. Please provide a different name.`, 6000);
            }
            else if(
                _.isEqual(updateCategoryQuery?.data?.statusCode, RESPONSE_TEMPLATE_COMPONENTS_MISMATCH_CODE) ||
                _.isEqual(updateCategoryQuery?.data?.statusCode, RESPONSE_TEMPLATE_BEARING_COMBINATION_CODE)
            ) {
                showInfoToast(`Category is applied in some equipment units. Adding or Removing of one or more components (or) bearings is not allowed`, 8000);
            }
            else if(_.isEqual(updateCategoryQuery?.data?.statusCode, RESPONSE_CATEGORY_JSON_ERROR)) {
                setUtils({ ...utils, jsonErrors: updateCategoryQuery.data?.data });
            }
            else {
                showErrorToast(`Failed to update ${utils.categoryCurrentInfo.name}`, 5000);
            }
            updateCategoryQuery.remove();
        }
    }, [fetchCategoriesQuery.isFetched, addCategoryQuery.isFetched, updateCategoryQuery.isFetched]);

    return (
        <>
            {
                utils.showGlobalCategoriesPopup &&
                    <GlobalCategoriesPopup closePopup={() => setUtils({ ...utils, showGlobalCategoriesPopup: false })} />
            }
            {
                !_.isEmpty(utils.categoryToDelete.id) &&
                    <DeleteCategoryPopup
                        id={utils.categoryToDelete.id} 
                        name={utils.categoryToDelete.name} 
                        closePopup={() => setUtils({ ...utils, categoryToDelete: {} })}
                    />
            }
            {
                !_.isEmpty(utils.jsonErrors) &&
                    <JsonSchemaBasedErrorPopup
                        name={utils.categoryCurrentInfo.name}
                        jsonErrors={utils.jsonErrors}
                        closePopup={() => setUtils({ ...utils, jsonErrors: [] })}
                    />
            }
            {
                (addCategoryQuery.isFetching || updateCategoryQuery.isFetching) &&
                    <AddOrUpdateCategoryLoadingPopup content={`${_.isEmpty(selectedCategoryId) ? "Adding" : "Updating"} ${utils.categoryCurrentInfo.name}`} />
            }
            <Card className="w-100 mx-1 equipment-unit-categories-container">
                <div className='category-management-header'>
                    <div className='m-3 f-17'>
                        <b className='pt-3'>Equipment Unit Categories</b> <br />
                        {
                            !fetchCategoriesQuery.isFetching && isLockedProfile.current &&
                                <span style={{ fontSize: "13px" }}>
                                    (Profile is locked)
                                </span>
                        }
                    </div>
                    <div className='category-management-header-icons'>
                        <Dropdown drop="left">
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                {
                                    (!isAddOrEditActive && (!fetchCategoriesQuery.isFetching && !isLockedProfile.current)) &&
                                        <Icon icon={'feather-more-vertical'} width={20} color='#075978' height={20} />
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu alightRight={true}>
                                {
                                    returnDropdownItem('', 'Create new category', () => handleIcons("ADD"), '', '', false)
                                }
                                {
                                    !props.checkIfUserInGlobalCategoriesPage() &&
                                        returnDropdownItem(
                                            '',
                                            'Clone from global categories',
                                            () => {
                                                setUtils({ ...utils, showGlobalCategoriesPopup: true });
                                                dispatch({ type: SELECT_OR_DESELECT_CATEGORY, payload: "" });
                                            },
                                            '',
                                            isAddOrEditActive ? 'grey' : '#075978',
                                            false
                                        )
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                        {
                            !isAddOrEditActive &&
                                returnIconBasedToolTip(
                                    'cursor-pointer',
                                    'feather-search',
                                    '#075978',
                                    () => setUtils({ ...utils, showSearchBox: !utils.showSearchBox }),
                                    "Search for category",
                                    "Search for category"
                                )
                        }
                    </div>
                </div>
                {
                    utils.showSearchBox &&
                        <Searchfield
                            inputChange={(e) => searchHook.setSearchValue(e.target.value)}
                            placeholder="Search for categories"
                            inputClear={() => searchHook.setSearchValue('')}
                            inputValue={searchHook.searchValue}
                        />
                }
                {
                    isAddOrEditActive && _.isEmpty(selectedCategoryId) && returnCategoryAddOrEditField()
                }
                {
                    fetchCategoriesQuery.isFetching ?
                        <div className='vertical-center-align h-100 justify-content-center'>
                            <ClipLoader className='text-center' color="#075978" />
                        </div>
                            :
                        <>
                            {
                                _.isEmpty(utils.categoriesList) && !isAddOrEditActive ?
                                    <div className='vertical-center-align justify-center h-100'>
                                        <h5>
                                            <b>No categories found</b>
                                        </h5>
                                    </div>
                                        :
                                    <PerfectScrollbar>
                                        {
                                            utils.categoriesList.map((item, ind) =>
                                                isAddOrEditActive && item.id === selectedCategoryId ?
                                                    returnCategoryAddOrEditField()
                                                        :
                                                    <div
                                                        onClick={() => dispatch({ type: SELECT_OR_DESELECT_CATEGORY, payload: item.id })} key={ind}
                                                        className={`
                                                            justify-content-between category-item 
                                                            ${selectedCategoryId === item.id && 'bg-selected'} 
                                                            ${isAddOrEditActive ? 'disable-click' : ''}`
                                                        }
                                                    >
                                                        <div className={'vertical-center-align pl-3 h-100'}>
                                                            {item.name}
                                                        </div>
                                                        {
                                                            selectedCategoryId === item.id && !isLockedProfile.current &&
                                                                <div className={`mr-4`}>
                                                                    <Dropdown drop="left">
                                                                        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                                                            <Icon className={`${isAddOrEditActive ? 'color-grey' : ''}`} icon="feather:more-vertical" color='#075978' />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu alightRight={true}>
                                                                            { 
                                                                                returnDropdownItem(
                                                                                    'feather-trash',
                                                                                    'Delete', 
                                                                                    () => setUtils({ ...utils, categoryToDelete: { id: item.id, name: item.name } }),
                                                                                    `${isAddOrEditActive && 'disable-click'} mx-2`,
                                                                                    'red',
                                                                                    true
                                                                                ) 
                                                                            }
                                                                            {
                                                                                returnDropdownItem(
                                                                                    'feather-edit-2', 
                                                                                    'Edit', 
                                                                                    () => dispatch({ type: SET_CATEGORY_IN_EDIT, payload: item.id }),
                                                                                    `${ isAddOrEditActive && 'disable-click' } mx-2 mt-1`,
                                                                                    isAddOrEditActive ? 'grey' : '#075978',
                                                                                    true
                                                                                ) 
                                                                            }
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                        }
                                                    </div>
                                            )
                                        }
                                    </PerfectScrollbar>
                            }
                        </>
                }
            </Card>
        </>
    );
}

export default CategoryList;